import { CircleSeriesNode } from '@modernhealth/circles-graphql';
import { SeriesAccessType } from '@modernhealth/circles-web-components';

export function isSeriesMembersOnly(series: Pick<CircleSeriesNode, 'accessType'> | undefined) {
    const isMembersOnly = series?.accessType === SeriesAccessType.MODERN_HEALTH_MEMBERS_ONLY;

    return isMembersOnly;
}
